import React, { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";

const UserMultiSelect = ({ options, value, onChange, label = "Select Users" }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen(!open);

  const handleSelect = (opt) => {
    const exists = value.some((v) => v.value === opt.value);

    if (exists) {
      onChange(value.filter((v) => v.value !== opt.value));
    } else {
      onChange([...value, opt]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="position-relative w-100 mb-3">
      <Form.Label>{label}</Form.Label>

      {/* Select Box */}
      {/* <div
        onClick={toggleDropdown}
        className="form-select"
        style={{ cursor: "pointer" }}
      >
        {value.length === 0 ? (
          <span className="text-muted">Select Users</span>
        ) : (
              value
            .map((v) => v?.label)
            .filter((lbl) => lbl && lbl.trim() !== "")
            .join(", ")
        )}
      </div> */}
      <div
  onClick={toggleDropdown}
  className="form-select d-flex flex-wrap align-items-center gap-1"
  style={{
    cursor: "pointer",
    minHeight: "38px",
    height: "auto",
    whiteSpace: "normal",
    overflow: "hidden"
  }}
>
  {value.length === 0 ? (
    <span className="text-muted">Select Users</span>
  ) : (
    value.map((v) => (
      <span
        key={v.value}
        className="badge bg-primary"
        style={{ fontSize: "12px" }}
      >
        {v.label}
      </span>
    ))
  )}
</div>


      {open && (
        <div
          className="border rounded bg-white position-absolute w-100 mt-1 p-2"
          style={{ zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}
        >
          {options.map((opt) => {
            const checked = value.some((v) => v.value === opt.value);
            return (
              <div
                key={opt.value}
                onClick={() => handleSelect(opt)}
                className="px-3 py-2 d-flex gap-2 align-items-center"
                style={{ cursor: "pointer" }}
              >
                <input type="checkbox" readOnly checked={checked} />
                {opt.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UserMultiSelect;
